import type { CliPromptTurnState } from '@buildautomaton/types';
import { sendPromptQueueClientReport } from '../client-report.js';
import { readPersistedQueue, writePersistedQueue } from '../disk-store.js';
import { deleteRunIdQueueKey } from './run-id-queue-key-map.js';

export async function finalizePromptTurnOnBridge(
  getWs: () => import('ws').default | null,
  runId: string | undefined,
  success: boolean,
  opts?: { terminalCliState?: CliPromptTurnState },
): Promise<boolean> {
  if (!runId) return false;
  const queueKey = deleteRunIdQueueKey(runId);
  if (!queueKey) return false;
  const f = await readPersistedQueue(queueKey);
  if (!f) return false;
  const t = f.turns.find((x) => x.turnId === runId);
  if (!t) return false;
  t.lastCliState = opts?.terminalCliState ?? (success ? 'stopped' : 'failed');
  await writePersistedQueue(f);
  sendPromptQueueClientReport(getWs(), { [queueKey]: [{ turnId: runId, cliState: t.lastCliState }] });
  return true;
}
